/**
 * The desktop shell's bridge, or null -- the ONE place the client asks
 * "am I running inside the Steam build?".
 *
 * No shell exists yet (ARCH-PLAN Phase 5), so on every platform we ship
 * today this returns null and every branch behind it is a no-op -- which is
 * exactly the optional-chained posture §4.4 prescribes for achievements
 * (`desktopBridge()?.unlockAchievement?.(id)`): call sites never ask first,
 * and the web build pays nothing.
 *
 * THE CONTRACT WS-17 IMPLEMENTS (packages/desktop preload, via
 * contextBridge.exposeInMainWorld):
 *
 *   globalThis.catWorldDesktop = {
 *     // §4.3 version skew: the public server refused this binary's dialect
 *     // (deny VERSION + close 4010).  The shell reacts -- says "This world
 *     // has been updated" (the sentence lives in join.js's SENTENCES,
 *     // keyed "version-steam"), greys out "Visit the shared world", and
 *     // leaves the player in the LOCAL world, which always matches because
 *     // the binary ships its own server.  mine is this build's
 *     // PROTO_VERSION; min/max are the server's window, or null when only
 *     // the 4010 close survived the trip.
 *     visitDenied({ mine, min, max }) {},
 *     // §4.4, later (WS-19): unlockAchievement(id) {},
 *   };
 *
 * Every read is guarded: a preload that half-loaded, or a hostile page
 * global of the wrong shape, must read as "no bridge" -- the same posture
 * the token helpers in index.js take toward localStorage.
 */

/** The shell's bridge object, or null on the web (and until WS-17 lands). */
export function desktopBridge() {
  try {
    const bridge = /** @type {Record<string, unknown>} */ (
      /** @type {unknown} */ (globalThis)
    )["catWorldDesktop"];
    return bridge && typeof bridge === "object"
      ? /** @type {Record<string, any>} */ (bridge)
      : null;
  } catch {
    return null;
  }
}
